import { render, staticRenderFns } from "./_Iframe.vue?vue&type=template&id=08ba21df&scoped=true&"
import script from "./_Iframe.vue?vue&type=script&lang=js&"
export * from "./_Iframe.vue?vue&type=script&lang=js&"
import style0 from "./_Iframe.vue?vue&type=style&index=0&id=08ba21df&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ba21df",
  null
  
)

export default component.exports